export const PRODUCT_CATEGORIES_SCREEN_CREATION_MODE = 'CREATION_MODE';
export const PRODUCT_CATEGORIES_SCREEN_EDIT_MODE = 'EDIT_MODE';